import * as t from 'io-ts';
export var Urn = t.string;